/** Hindi. Keys are the English text; see i18n.ts. To be reviewed by a native speaker before release. */
export const hi: Record<string, string> = {
  // top bar and menus
  Mailbox: 'मेलबॉक्स',
  Notifications: 'सूचनाएँ',
  'New order': 'नया ऑर्डर',
  View: 'देखें',
  Account: 'खाता',
  Settings: 'सेटिंग्स',
  'Keyboard shortcuts': 'कीबोर्ड शॉर्टकट',
  'Welcome guide': 'स्वागत मार्गदर्शिका',
  'Install as an app': 'ऐप के रूप में इंस्टॉल करें',
  'Sign out': 'साइन आउट',
  'New chart': 'नया चार्ट',
  'Compact layout': 'संक्षिप्त लेआउट',
  'Profiles…': 'प्रोफ़ाइल…',
  'Reset layout': 'लेआउट रीसेट करें',
  // panels
  'Market Watch': 'मार्केट वॉच',
  Trade: 'ट्रेड',
  History: 'इतिहास',
  'New Order': 'नया ऑर्डर',
  Challenge: 'चैलेंज',
  Alerts: 'अलर्ट',
  'Tick chart': 'टिक चार्ट',
  'Data Window': 'डेटा विंडो',
  // settings
  Appearance: 'रूप-रंग',
  'Time and numbers': 'समय और संख्याएँ',
  Trading: 'ट्रेडिंग',
  Done: 'हो गया',
  Language: 'भाषा',
  // sign-in
  'Sign in': 'साइन इन करें',
  'Trade, chart and manage your account.': 'ट्रेड करें, चार्ट देखें और अपना खाता संभालें।',
  'Account number': 'खाता संख्या',
  Email: 'ईमेल',
  Password: 'पासवर्ड',
  'Remember my account number on this device': 'इस डिवाइस पर मेरी खाता संख्या याद रखें',
  'Signing in…': 'साइन इन हो रहा है…',
  'Forgot your password?': 'पासवर्ड भूल गए?',
  'New here?': 'नए हैं?',
  'Open a demo account': 'डेमो खाता खोलें',
  'Investor sign-in': 'निवेशक साइन-इन',
  'Investor password': 'निवेशक पासवर्ड',
  'View the account': 'खाता देखें',
  'View this account with its investor password. You can look, but not trade or change anything.':
    'निवेशक पासवर्ड से खाता देखें। आप देख सकते हैं, पर ट्रेड या कोई बदलाव नहीं कर सकते।',
  'Use the investor (read-only) password': 'निवेशक (केवल देखने वाला) पासवर्ड इस्तेमाल करें',
  'Use my own password instead': 'इसके बजाय मेरा अपना पासवर्ड इस्तेमाल करें',
  'Email me a link': 'मुझे लिंक ईमेल करें',
  'Back to sign in': 'साइन इन पर वापस जाएँ',
  'Choose a new password': 'नया पासवर्ड चुनें',
  'New password': 'नया पासवर्ड',
  'Repeat the new password': 'नया पासवर्ड दोबारा लिखें',
  'Set the new password': 'नया पासवर्ड सेट करें',
};
